// src/components/account-summary-widget/loyalty-account-summary-widget.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    __typename\n    theme\n    size\n    text\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LoyaltyAccountTravelerFragment on LoyaltyAccountTraveler {\n    __typename\n    title\n    emailAddress\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n\n    ... on Illustration {\n      ...EGDSIllustrationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    text\n    theme\n    weight\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSTextFragment on EGDSText {\n    __typename\n    ...EGDSPlainTextFragment\n    ...EGDSStandardLinkFragment\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InfoIconFragment on Icon {\n    __typename\n    description\n    title\n    id\n    token\n    size\n    theme\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LoyaltyIconInfoContentSectionFragment on LoyaltyIconInfoContentSection {\n    __typename\n    actionText\n    description\n    heading\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LoyaltyIconAndDescriptionFragment on LoyaltyIconAndDescription {\n    __typename\n    iconInfoContentSection {\n      ...LoyaltyIconInfoContentSectionFragment\n    }\n    infoIcon {\n      ...InfoIconFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LoyaltyProgramTitleFragment on LoyaltyProgramTitle {\n    __typename\n    text\n    superScript\n    infoIconAndDescription {\n      ...LoyaltyIconAndDescriptionFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LoyaltyRewardsValueSectionFragment on LoyaltyRewardsValueSection {\n    __typename\n    title {\n      ...LoyaltyProgramTitleFragment\n    }\n    rewardsAmount\n    supportingMessages {\n      ...EGDSTextFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  fragment UILinkActionFragment on UILinkAction {\n    accessibility\n    resource {\n      __typename\n      value\n    }\n    analytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    __typename\n    action {\n      ...UILinkActionFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LoyaltyViewRewardsLinkSectionFragment on LoyaltyViewRewardsLinkSection {\n    __typename\n    containerLink {\n      ...EGDSInlineLinkFragment\n    }\n    rewardsIcon {\n      ...EGDSIconFragment\n    }\n    rewardsText\n    containerLinkAnalytics {\n      payload\n      eventName\n      eventVersion\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  query LoyaltyAccountSummary($context: ContextInput!, $strategy: LoyaltyExperienceStrategy!, $viewId: String) {\n    loyaltyAccountSummary(context: $context, strategy: $strategy, viewId: $viewId) {\n      __typename\n      traveler {\n        ...LoyaltyAccountTravelerFragment\n      }\n      tierBadge {\n        ...EGDSStandardBadgeFragment\n      }\n      viewRewardsLinkSection {\n        ...LoyaltyViewRewardsLinkSectionFragment\n      }\n      availableValueSection {\n        ...LoyaltyRewardsValueSectionFragment\n      }\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
import React19 from "react";
import { gql as gql19, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/constants/loyalty-constants.ts
var UNIVERSAL_PROFILE_BASIC_INFO_SIGNAL = "UNIVERSAL_PROFILE_BASIC_INFO_UPDATED";
var LOYALTY_REWARDS_ERROR_SIGNAL = "LOYALTY_REWARDS_ERROR_SIGNAL";
// ../internal/src/components/egds-standard-badge/egds-standard-badge.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkBadgeLoyalty } from "uitk-react-badge";
var fragment = gql(_templateObject());
var EGDSStandardBadge = function(param) {
    var data = param.data;
    var theme = data.theme, size = data.size, text = data.text;
    var selectedTheme = theme ? theme : void 0;
    var selectedSize = size ? size : void 0;
    return /* @__PURE__ */ React.createElement(UitkBadgeLoyalty, {
        text: text || void 0,
        theme: selectedTheme,
        size: selectedSize
    });
};
EGDSStandardBadge.fragment = fragment;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// ../internal/src/components/loyalty-account-traveler/loyalty-account-traveler.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkHeading, UitkText } from "uitk-react-text";
var fragment2 = gql2(_templateObject1());
var LoyaltyAccountTraveler = function(param) {
    var data = param.data;
    var title = data.title, emailAddress = data.emailAddress;
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(UitkHeading, null, title), /* @__PURE__ */ React2.createElement(UitkText, null, emailAddress));
};
LoyaltyAccountTraveler.fragment = fragment2;
LoyaltyAccountTraveler.displayName = "LoyaltyAccountTraveler";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-rewards-value-section.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment3 = gql3(_templateObject2());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React3.createElement(UitkText2, {
        className: className,
        inline: inline,
        size: size
    }, text);
};
EGDSPlainText.fragment = fragment3;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
import { UitkText as UitkText3 } from "uitk-react-text";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var __EGDSIconFragment = gql4(_templateObject3());
var EGDSIcon = function(param) {
    var className = param.className, data = param.data;
    var spotlight = (data === null || data === void 0 ? void 0 : data.withBackground) ? "info" : void 0;
    var _data_title, _data_theme;
    return /* @__PURE__ */ React4.createElement(UitkIcon, {
        className: className,
        description: data === null || data === void 0 ? void 0 : data.description,
        id: data === null || data === void 0 ? void 0 : data.id,
        name: data !== null ? data.id : "",
        size: (data === null || data === void 0 ? void 0 : data.size) ? UitkIconSize[data.size] : void 0,
        title: (_data_title = data === null || data === void 0 ? void 0 : data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: (_data_theme = data === null || data === void 0 ? void 0 : data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
        spotlight: spotlight
    });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-illustration.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var __EGDSIllustrationFragment = gql5(_templateObject4());
var EGDSIllustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React5.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
EGDSIllustration.displayName = "Illustration";
EGDSIllustration.fragment = __EGDSIllustrationFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var __EGDSMarkFragment = gql6(_templateObject5());
var EGDSMark = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    var _data_url;
    /* @__PURE__ */ return React6.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: markSize || data.markSize && UitkMarkSize[data.markSize],
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
var __EGDSGraphicFragment = gql7(_templateObject6(), EGDSIcon.fragment, EGDSMark.fragment, EGDSIllustration.fragment);
var EGDSGraphic = function(param) {
    var className = param.className, markSize = param.markSize, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React7.createElement(EGDSIcon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React7.createElement(EGDSMark, {
                className: className,
                data: data,
                markSize: markSize
            });
        case "Illustration":
            return /* @__PURE__ */ React7.createElement(EGDSIllustration, {
                data: data
            });
        default:
            return null;
    }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
var _obj;
// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = (_obj = {}, _defineProperty(_obj, "SMALL" /* SMALL */ , "small"), _defineProperty(_obj, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj, "LARGE" /* LARGE */ , "large"), _obj);
var _obj1;
var UILinkTargetMap = (_obj1 = {}, _defineProperty(_obj1, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj1, "INTERNAL" /* INTERNAL */ , "_self"), _obj1);
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment4 = gql8(_templateObject7(), EGDSIcon.fragment);
var IconPlacement = function(param) {
    var icon = param.icon, iconPosition = param.iconPosition, iconPositionToMatch = param.iconPositionToMatch;
    if (icon && iconPosition === iconPositionToMatch) {
        return /* @__PURE__ */ React8.createElement(EGDSIcon, {
            data: icon
        });
    }
    return null;
};
var EGDSStandardLink = function(param) {
    var className = param.className, dataStid = param.dataStid, inline = param.inline, theme = param.theme, align = param.align, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, useRelativePath = _param_data_action.useRelativePath, disabled = _param_data.disabled, iconPosition = _param_data.iconPosition, standardLinkIcon = _param_data.standardLinkIcon, size = _param_data.size, text = _param_data.text;
    var clickTracker = useClickTracker();
    var onClick = React8.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    var getPath = React8.useCallback(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    return /* @__PURE__ */ React8.createElement(UitkLink, {
        className: className,
        "data-stid": dataStid,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        inline: inline,
        disabled: disabled,
        theme: theme || "default",
        align: align
    }, /* @__PURE__ */ React8.createElement("a", {
        target: UILinkTargetMap[target],
        href: getPath()
    }, /* @__PURE__ */ React8.createElement(IconPlacement, {
        icon: standardLinkIcon,
        iconPosition: iconPosition,
        iconPositionToMatch: "LEADING" /* LEADING */ 
    }), text, /* @__PURE__ */ React8.createElement(IconPlacement, {
        icon: standardLinkIcon,
        iconPosition: iconPosition,
        iconPositionToMatch: "TRAILING" /* TRAILING */ 
    }), accessibility && /* @__PURE__ */ React8.createElement(UitkText3, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment4;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment5 = gql9(_templateObject8());
var TextThemeMapper = /* @__PURE__ */ function(TextThemeMapper2) {
    TextThemeMapper2["INVERSE"] = "inverse";
    TextThemeMapper2["LOYALTY"] = "loyalty";
    TextThemeMapper2["NEGATIVE"] = "negative";
    TextThemeMapper2["POSITIVE"] = "positive";
    TextThemeMapper2["PENDING"] = "default";
    return TextThemeMapper2;
}(TextThemeMapper || {});
var _obj2;
var textWeightMapper = (_obj2 = {}, _defineProperty(_obj2, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj2, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj2, "REGULAR" /* REGULAR */ , "regular"), _obj2);
var EGDSStylizedText = function(param) {
    var data = param.data, whiteSpace = param.whiteSpace;
    var text = data.text, theme = data.theme, weight = data.weight;
    return /* @__PURE__ */ React9.createElement(UitkText4, {
        theme: theme ? TextThemeMapper[theme] : void 0,
        whiteSpace: whiteSpace,
        weight: weight ? textWeightMapper[weight] : void 0
    }, text);
};
EGDSStylizedText.fragment = fragment5;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-text.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
var fragment6 = gql10(_templateObject9(), EGDSPlainText.fragment, EGDSStandardLink.fragment);
var EGDSText = function(param) {
    var data = param.data, standardLinkProps = param.standardLinkProps, plainTextProps = param.plainTextProps;
    var __typename = data.__typename;
    switch(__typename){
        case "EGDSStandardLink":
            return /* @__PURE__ */ React10.createElement(EGDSStandardLink, _objectSpread({
                data: data
            }, standardLinkProps));
        case "EGDSPlainText":
            return /* @__PURE__ */ React10.createElement(EGDSPlainText, _objectSpread({
                data: data
            }, plainTextProps));
        default:
            return null;
    }
};
EGDSText.fragment = fragment6;
EGDSText.displayName = "EGDSText";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-program-title.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkText as UitkText6 } from "uitk-react-text";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-icon-and-description.tsx
import React13, { useRef } from "react";
import { gql as gql13 } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkButtonSize, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkDialog, UitkDialogContent } from "uitk-react-dialog";
// ../internal/src/components/loyalty-rewards-value-section/info-icon.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var fragment7 = gql11(_templateObject10());
var InfoIcon = function(param) {
    var data = param.data;
    var description = data.description, title = data.title, id = data.id, token = data.token, size = data.size, theme = data.theme;
    var iconSize = size ? UitkIconSize2[size] : void 0;
    var iconTheme = theme !== null && theme !== void 0 ? theme : void 0;
    return /* @__PURE__ */ React11.createElement(UitkIcon2, {
        id: id,
        title: title || void 0,
        description: description,
        name: id,
        size: iconSize,
        theme: iconTheme
    });
};
InfoIcon.fragment = fragment7;
InfoIcon.displayName = "InfoIcon";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-icon-info-content-section.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkHeading as UitkHeading2, UitkText as UitkText5 } from "uitk-react-text";
var fragment8 = gql12(_templateObject11());
var LoyaltyIconInfoContentSection = function(param) {
    var data = param.data, onClick = param.onClick;
    var actionText = data.actionText, description = data.description, heading = data.heading;
    return /* @__PURE__ */ React12.createElement(UitkLayoutFlex, {
        direction: "column",
        space: "four"
    }, /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React12.createElement(UitkHeading2, null, heading)), /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React12.createElement(UitkText5, null, description)), /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React12.createElement(UitkTertiaryButton, {
        key: "UitkDialogFooter",
        onClick: onClick
    }, actionText)));
};
LoyaltyIconInfoContentSection.fragment = fragment8;
LoyaltyIconInfoContentSection.displayName = "LoyaltyIconInfoContentSection";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-icon-and-description.tsx
var fragment9 = gql13(_templateObject12(), LoyaltyIconInfoContentSection.fragment, InfoIcon.fragment);
var LoyaltyIconAndDescription = function(param) {
    var data = param.data;
    var triggerRef = useRef();
    var infoIcon = data.infoIcon, iconInfoContentSection = data.iconInfoContentSection;
    var _useDialog = _slicedToArray(useDialog("one-key-info-dialog"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(DialogComponent, null, /* @__PURE__ */ React13.createElement(UitkDialog, {
        dialogShow: isDialogOpen
    }, /* @__PURE__ */ React13.createElement(UitkDialogContent, {
        key: "dialogContent1"
    }, /* @__PURE__ */ React13.createElement(LoyaltyIconInfoContentSection, {
        data: iconInfoContentSection,
        onClick: function() {
            return dialogActions.closeDialog();
        }
    })))), /* @__PURE__ */ React13.createElement(UitkTertiaryButton2, {
        onClick: function() {
            return dialogActions.openDialog();
        },
        type: "button",
        size: UitkButtonSize.SMALL
    }, /* @__PURE__ */ React13.createElement(InfoIcon, {
        data: infoIcon
    })));
};
LoyaltyIconAndDescription.fragment = fragment9;
LoyaltyIconAndDescription.displayName = "LoyaltyIconAndDescription";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-program-title.tsx
var fragment10 = gql14(_templateObject13(), LoyaltyIconAndDescription.fragment);
var LoyaltyProgramTitle = function(param) {
    var data = param.data;
    var text = data.text, superScript = data.superScript, infoIconAndDescription = data.infoIconAndDescription;
    return /* @__PURE__ */ React14.createElement(UitkLayoutFlex2, {
        alignItems: "center"
    }, /* @__PURE__ */ React14.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React14.createElement(UitkText6, null, text, " ", /* @__PURE__ */ React14.createElement("sup", null, superScript))), /* @__PURE__ */ React14.createElement(UitkLayoutFlexItem2, null, infoIconAndDescription ? /* @__PURE__ */ React14.createElement(LoyaltyIconAndDescription, {
        data: infoIconAndDescription
    }) : null));
};
LoyaltyProgramTitle.fragment = fragment10;
LoyaltyProgramTitle.displayName = "LoyaltyProgramTitle";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-rewards-value-section.tsx
var fragment11 = gql15(_templateObject14(), LoyaltyProgramTitle.fragment, EGDSText.fragment);
var LoyaltyRewardsValueSection = function(param) {
    var data = param.data;
    var title = data.title, rewardsAmount = data.rewardsAmount, supportingMessages = data.supportingMessages;
    return /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(LoyaltyProgramTitle, {
        data: title
    }), /* @__PURE__ */ React15.createElement(UitkHeading3, null, rewardsAmount), supportingMessages === null || supportingMessages === void 0 ? void 0 : supportingMessages.map(function(supportingMessage, index) {
        return /* @__PURE__ */ React15.createElement(EGDSText, {
            data: supportingMessage,
            standardLinkProps: {
                inline: true
            },
            key: index
        });
    }));
};
LoyaltyRewardsValueSection.fragment = fragment11;
LoyaltyRewardsValueSection.displayName = "LoyaltyRewardsValueSection";
// ../internal/src/components/loyalty-view-rewards-link-section/loyalty-view-rewards-link-section.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkText as UitkText7 } from "uitk-react-text";
// ../internal/src/components/egds-inline-link/egds-inline-link.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
// ../internal/src/components/egds-inline-link/ui-link-action.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { useClickTracker as useClickTracker2, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var fragment12 = gql16(_templateObject15());
var UILinkAction = function(param) {
    var children = param.children, data = param.data, clickstreamAnalyticsData = param.clickstreamAnalyticsData;
    var resource = data.resource, analytics = data.analytics, accessibility = data.accessibility;
    var clickTracker = useClickTracker2();
    var track = useEgClickstream();
    var onClickCapture = React16.useCallback(function() {
        if (analytics) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
        if ((clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.serverPayload) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventName) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventVersion)) {
            track({
                clientPayload: {
                    event: {
                        event_name: clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventName,
                        event_version: clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventVersion
                    }
                },
                serverPayload: clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.serverPayload
            });
        }
    }, [
        analytics,
        clickTracker,
        track
    ]);
    return /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement("a", {
        href: resource.value,
        onClickCapture: onClickCapture,
        "aria-label": accessibility || ""
    }, children));
};
UILinkAction.fragment = fragment12;
UILinkAction.displayName = "UILinkAction";
// ../internal/src/components/egds-inline-link/egds-inline-link.tsx
var fragment13 = gql17(_templateObject16(), UILinkAction.fragment);
var EGDSInlineLink = function(param) {
    var children = param.children, data = param.data, clickstreamAnalyticsData = param.clickstreamAnalyticsData;
    return /* @__PURE__ */ React17.createElement(UILinkAction, {
        data: data.action,
        clickstreamAnalyticsData: clickstreamAnalyticsData
    }, children);
};
EGDSInlineLink.fragment = fragment13;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/loyalty-view-rewards-link-section/loyalty-view-rewards-link-section.tsx
var fragment14 = gql18(_templateObject17(), EGDSInlineLink.fragment, EGDSIcon.fragment);
var LoyaltyViewRewardsLinkSection = function(param) {
    var data = param.data;
    var containerLink = data.containerLink, rewardsIcon = data.rewardsIcon, rewardsText = data.rewardsText, containerLinkAnalytics = data.containerLinkAnalytics;
    var clickstreamAnalyticsData = {
        serverPayload: containerLinkAnalytics === null || containerLinkAnalytics === void 0 ? void 0 : containerLinkAnalytics.payload,
        eventName: containerLinkAnalytics === null || containerLinkAnalytics === void 0 ? void 0 : containerLinkAnalytics.eventName,
        eventVersion: containerLinkAnalytics === null || containerLinkAnalytics === void 0 ? void 0 : containerLinkAnalytics.eventVersion
    };
    return containerLink ? /* @__PURE__ */ React18.createElement(EGDSInlineLink, {
        data: containerLink,
        clickstreamAnalyticsData: clickstreamAnalyticsData
    }, /* @__PURE__ */ React18.createElement(UitkLayoutFlex3, {
        alignItems: "center",
        space: "four"
    }, rewardsIcon ? /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React18.createElement(EGDSIcon, {
        data: rewardsIcon
    })) : null, /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem3, {
        grow: 1
    }, /* @__PURE__ */ React18.createElement(UitkText7, {
        theme: "global-loyalty"
    }, rewardsText)), /* @__PURE__ */ React18.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React18.createElement(UitkIcon3, {
        name: "chevron_right",
        theme: "default"
    })))) : null;
};
LoyaltyViewRewardsLinkSection.fragment = fragment14;
LoyaltyViewRewardsLinkSection.displayName = "LoyaltyViewRewardsLinkSection";
// src/components/account-summary-widget/loyalty-account-summary-widget.tsx
import { useSignalPublisher, useSignalSubscriber } from "@shared-ui/signal-events-context";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLoader } from "uitk-react-loader";
// src/__generated__/globalTypes.ts
var LoyaltyExperienceStrategy = /* @__PURE__ */ function(LoyaltyExperienceStrategy2) {
    LoyaltyExperienceStrategy2["HIDE_TRAVELER_INFO_AND_REWARDS_LINK"] = "HIDE_TRAVELER_INFO_AND_REWARDS_LINK";
    LoyaltyExperienceStrategy2["SHOW_TRAVELER_INFO_AND_REWARDS_LINK"] = "SHOW_TRAVELER_INFO_AND_REWARDS_LINK";
    return LoyaltyExperienceStrategy2;
}(LoyaltyExperienceStrategy || {});
// src/components/account-summary-widget/loyalty-account-summary-widget.tsx
var __Query = gql19(_templateObject18(), LoyaltyAccountTraveler.fragment, EGDSStandardBadge.fragment, LoyaltyViewRewardsLinkSection.fragment, LoyaltyRewardsValueSection.fragment);
var LoyaltyAccountSummaryWidget = function(props) {
    var skipSsr = props.skipSsr, inputs = props.inputs;
    var context = useBexApi().context;
    var variables = _objectSpread({
        context: context
    }, inputs);
    var publishSignal = useSignalPublisher().publishSignal;
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, refetch = _useQuery.refetch;
    useSignalSubscriber([
        {
            query: {
                type: UNIVERSAL_PROFILE_BASIC_INFO_SIGNAL
            },
            callback: function() {
                refetch();
            }
        }
    ]);
    if (loading) {
        return /* @__PURE__ */ React19.createElement(UitkLayoutFlex4, {
            justifyContent: "center"
        }, /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React19.createElement(UitkLoader, null))));
    }
    if (error || !data || !data.loyaltyAccountSummary) {
        publishSignal({
            type: LOYALTY_REWARDS_ERROR_SIGNAL,
            payload: {}
        });
        return null;
    }
    var _data_loyaltyAccountSummary = data.loyaltyAccountSummary, traveler = _data_loyaltyAccountSummary.traveler, tierBadge = _data_loyaltyAccountSummary.tierBadge, viewRewardsLinkSection = _data_loyaltyAccountSummary.viewRewardsLinkSection, availableValueSection = _data_loyaltyAccountSummary.availableValueSection, impressionAnalytics = _data_loyaltyAccountSummary.impressionAnalytics;
    var isTravelerInfoAndRewardsLinkHidden = inputs.strategy === "HIDE_TRAVELER_INFO_AND_REWARDS_LINK" /* HIDE_TRAVELER_INFO_AND_REWARDS_LINK */ ;
    var TravelerAndTierBadgeSection = function() {
        if (traveler && tierBadge) {
            return /* @__PURE__ */ React19.createElement(UitkLayoutFlex4, {
                alignItems: "center"
            }, /* @__PURE__ */ React19.createElement(UitkLayoutFlexItem4, {
                grow: 1
            }, /* @__PURE__ */ React19.createElement(UitkLayoutFlex4, {
                direction: "column"
            }, /* @__PURE__ */ React19.createElement(LoyaltyAccountTraveler, {
                data: traveler
            }))), /* @__PURE__ */ React19.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React19.createElement(EGDSStandardBadge, {
                data: tierBadge
            })));
        }
        if (traveler) {
            return /* @__PURE__ */ React19.createElement(LoyaltyAccountTraveler, {
                data: traveler
            });
        }
        if (tierBadge) {
            return /* @__PURE__ */ React19.createElement(EGDSStandardBadge, {
                data: tierBadge
            });
        }
        return null;
    };
    var availableValueComponent = availableValueSection && /* @__PURE__ */ React19.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React19.createElement(UitkCardContentSection, {
        padded: [
            "blockend",
            "inlinestart",
            "inlineend"
        ]
    }, /* @__PURE__ */ React19.createElement(UitkLayoutFlex4, {
        direction: "column",
        alignItems: isTravelerInfoAndRewardsLinkHidden ? "center" : void 0
    }, /* @__PURE__ */ React19.createElement(LoyaltyRewardsValueSection, {
        data: availableValueSection
    }))));
    return /* @__PURE__ */ React19.createElement(UitkCard, null, /* @__PURE__ */ React19.createElement(UitkLayoutFlex4, {
        direction: "column",
        alignItems: isTravelerInfoAndRewardsLinkHidden ? "center" : void 0
    }, /* @__PURE__ */ React19.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React19.createElement(UitkCardContentSection, null, /* @__PURE__ */ React19.createElement(TravelerAndTierBadgeSection, null))), impressionAnalytics ? /* @__PURE__ */ React19.createElement(IntersectionTracker, {
        referrerId: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId,
        linkName: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName
    }, availableValueComponent) : availableValueComponent, viewRewardsLinkSection ? /* @__PURE__ */ React19.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React19.createElement(UitkCardContentSection, {
        padded: [
            "blockend",
            "inlinestart",
            "inlineend"
        ]
    }, /* @__PURE__ */ React19.createElement(LoyaltyViewRewardsLinkSection, {
        data: viewRewardsLinkSection
    }))) : null));
};
LoyaltyAccountSummaryWidget.displayName = "Loyalty Account Summary Widget";
export { LoyaltyAccountSummaryWidget, LoyaltyExperienceStrategy }; /* istanbul ignore file -- @preserve */ 
//# sourceMappingURL=index.js.map